import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { useAuth } from "../../context/AuthContext";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Page = styled.div`
  min-height: 100vh;
  background: #0a0a0a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Georgia", serif;
`;

const Box = styled.div`
  animation: ${fadeIn} 0.6s ease forwards;
  width: 100%;
  max-width: 400px;
  padding: 48px 40px;
  border: 1px solid #222;
  background: #111;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
  color: #555;
  font-size: 0.8rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin: 0 0 40px 0;
`;

const Field = styled.div`
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  color: #666;
  font-size: 0.7rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

const Input = styled.input`
  width: 100%;
  background: #0a0a0a;
  border: 1px solid #2a2a2a;
  color: #fff;
  padding: 12px 14px;
  font-size: 0.95rem;
  font-family: "Georgia", serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s;

  &:focus {
    border-color: #666;
  }
`;

const ErrorMsg = styled.p`
  color: #c0392b;
  font-size: 0.8rem;
  margin: 0 0 20px 0;
  letter-spacing: 0.05em;
`;

const Button = styled.button`
  width: 100%;
  background: #fff;
  color: #0a0a0a;
  border: none;
  padding: 14px;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Georgia", serif;
  margin-top: 8px;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover {
    background: #ccc;
  }

  &:disabled {
    background: #333;
    color: #666;
    cursor: not-allowed;
  }
`;

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page>
      <Box>
        <Title>Admin</Title>
        <Subtitle>Restricted Access</Subtitle>
        <form onSubmit={handleSubmit}>
          <Field>
            <Label>Email</Label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </Field>
          <Field>
            <Label>Password</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </Field>
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <Button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </Box>
    </Page>
  );
};

export default AdminLogin;
